import "./rangeSlider.css";

const TrackerRangeSlider = ({ labels, value, children }) => {
  return (
    <div className="d-flex align-items-start flex-column justify-content-between gap-10 w-100">
      <div className="range-wrapper">
        {/* <label for="frequency-range" class="range-label infrequent">Infrequent</label> */}
        {/* <input type="range" id="frequency-range" class="frequency-range" value="70" /> */}
        {children}
        {/* <label for="frequency-range" class="range-label frequent">Frequent</label> */}
      </div>
      <div className="d-flex justify-content-between w-100">
        <p className="m-0" style={{ color: "#C03017", fontSize: "14px", fontWeight: 700 }}>{labels?.[0] || ""}</p>
        <p className="m-0" class="range-percentage">{value}%</p>
        <p className="m-0" style={{ color: "#A3DF00", fontSize: "14px", fontWeight: 700 }}>{labels?.[1] || ""}</p>
      </div>
    </div>
  )
}

export default TrackerRangeSlider;